<template>
  <div class="percentManagement-container">
    <el-row class="percentManagement-top">
      <el-row class="top-title">整体进度</el-row>
      <el-row class="top-content">
        <el-col :span="10" class="percentCharts" id="percentCharts"></el-col>
        <el-col :span="4" class="number">
          <el-row class="number-top">{{
            $judgeEmptyZ(percentData.totalPoints)
          }}</el-row>
          <el-row class="number-bottom">点位总数</el-row>
        </el-col>
        <el-col :span="10" class="proportion">
          <el-row class="proportion-wrapper">
            <el-col :span="4" class="content">
              <div class="molecule">
                {{ $judgeEmptyZ(percentData.completionPoint) }}
              </div>
              <div class="text">已完成</div>
            </el-col>
            <el-col :span="2" class="line">/</el-col>
            <el-col :span="4" class="content">
              <div class="denominator">
                {{ $judgeEmptyZ(percentData.hangInTheAir) }}
              </div>
              <div class="text">未完成</div>
            </el-col>
            <el-col :span="2" class="line">/</el-col>
            <el-col :span="4" class="content">
              <div class="yesterday">
                {{ $judgeEmptyZ(percentData.pastPoint) }}
              </div>
              <div class="text">昨日完成</div>
            </el-col>
            <el-col :span="2" class="line">/</el-col>
            <el-col :span="4" class="content">
              <div class="today">
                {{ $judgeEmptyZ(percentData.plannedPoint) }}
              </div>
              <div class="text">今日计划</div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-row>
    <el-row class="percentManagement-bottom">
      <el-row class="top-title">计划表</el-row>
      <el-row class="bottom-content">
        <el-row class="percentManagement-form">
          <el-form
            inline
            :model="queryForm"
            ref="queryForm"
            :rules="rules"
            class="demo-form-inline"
          >
            <el-form-item prop="startTime">
              <el-date-picker
                v-model="queryForm.startTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="开始时间"
              >
              </el-date-picker>
            </el-form-item>
            <span class="line-row">-</span>
            <el-form-item class="r-20" prop="endTime">
              <el-date-picker
                v-model="queryForm.endTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="结束时间"
              >
              </el-date-picker>
              <!-- <el-date-picker
                v-model="queryForm.time"
                type="date"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                :picker-options="expireTimeOption"
              >
              </el-date-picker> -->
            </el-form-item>
            <el-form-item class="r-20" prop="operationTeam">
              <el-input
                v-model.trim="queryForm.operationTeam"
                @keyup.enter.native="query"
                placeholder="班组名称"
              ></el-input>
            </el-form-item>
            <el-form-item class="r-20" prop="areaIds">
              <el-cascader
                v-model="queryForm.areaIds"
                :options="areaList"
                :props="optionProps"
                clearable
                collapse-tags
                placeholder="请选择作业区域"
              >
                <template slot-scope="{ node, data }">
                  <span>{{ data.label }}</span>
                  <!-- <span v-if="!node.isLeaf">
                    ({{ data.children.length }})
                  </span> -->
                </template>
              </el-cascader>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="query">查询</el-button>
              <el-button @click="reset">取消</el-button>
              <el-button type="primary" @click="exportData">数据导出</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <el-row class="percentManagement-table">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            size="mini"
            highlight-current-row
            v-loading="loading"
            element-loading-text="拼命加载中"
          >
            <el-table-column
              type="index"
              label="序号"
              width="70"
              align="center"
            ></el-table-column>
            <el-table-column
              label="班组名称"
              min-width="100"
              prop="operationTeam"
            ></el-table-column>
            <el-table-column
              label="单位名称"
              min-width="100"
              prop="companyName"
            ></el-table-column>
            <el-table-column
              label="使用部门"
              min-width="100"
              prop="department"
            ></el-table-column>
            <el-table-column
              label="作业区域"
              min-width="100"
              prop="areaName"
            ></el-table-column>
            <el-table-column
              label="班组人员"
              min-width="80"
              prop="personnelName"
            >
              <template slot-scope="scope">
                <span class="list-detail" @click="toUnitManager(scope.row)">{{
                  scope.row.personnelName
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="班组车辆" min-width="100" prop="plateNum">
              <template slot-scope="scope">
                <span
                  class="list-detail"
                  @click="toVehicleInfo(scope.row.vin)"
                  >{{ scope.row.plateNum }}</span
                >
              </template></el-table-column
            >
            <el-table-column label="计划清单" min-width="100" prop="schedule">
              <template slot-scope="scope">
                <span class="list-detail" @click="listDetail(scope.row)"
                  >清单详情</span
                >
              </template>
            </el-table-column>
            <el-table-column
              label="预计用时"
              min-width="140"
              prop="estimatedTime"
            ></el-table-column>
            <el-table-column
              label="计划点位"
              min-width="100"
              prop="plannedPoint"
            ></el-table-column>
            <el-table-column
              label="已完成点位"
              min-width="100"
              prop="finishedpoint"
            ></el-table-column>
            <el-table-column
              label="完成率"
              min-width="120"
              prop="completionRate"
            ></el-table-column>
            <el-table-column
              label="计划生成时间"
              min-width="140"
              prop="addTime"
            ></el-table-column>
          </el-table>
        </el-row>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-size="limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </el-row>
    </el-row>
    <!--清单详情-->
    <el-dialog
      title="清单详情"
      :visible.sync="listVisibility"
      class="list-dialog"
      ref="amapDialog"
    >
      <el-row class="top">
        <div class="table-left">
          <table border="1" cellspacing="0">
            <tr>
              <th>班组总点位</th>
              <th>已完成</th>
              <th>未完成</th>
              <th>昨日任务</th>
              <th>今日任务</th>
            </tr>
            <tr>
              <td>{{ $judgeEmpty(detailTableData.totalPoints) }}</td>
              <td>{{ $judgeEmpty(detailTableData.completionPoint) }}</td>
              <td>{{ $judgeEmpty(detailTableData.hangInTheAir) }}</td>
              <td>{{ $judgeEmpty(detailTableData.pastPoint) }}</td>
              <td>{{ $judgeEmpty(detailTableData.plannedPoint) }}</td>
            </tr>
          </table>
        </div>
        <div class="table-right">
          <table border="1" cellspacing="0">
            <tr>
              <th>班组车辆</th>
              <th>班组人员</th>
              <th>联系电话</th>
              <th>剩余油量</th>
              <th>剩余保养里程</th>
            </tr>
            <tr>
              <td>{{ $judgeEmpty(detailTableData.plate) }}</td>
              <td>{{ $judgeEmpty(detailTableData.personnelName) }}</td>
              <td>{{ $judgeEmpty(detailTableData.phone) }}</td>
              <td>{{ detailTableData.oilVolume }}</td>
              <td>{{ detailTableData.maintainMileage }}</td>
            </tr>
          </table>
        </div>
      </el-row>
      <el-row class="bottom">
        <div v-if="!noData" class="steps">
          <el-row
            class="one-steps"
            v-for="steps in stepsListData"
            :key="steps.id"
          >
            <el-col :span="2" class="left">
              <div class="steps-number">{{ steps.serialNo }}</div>
              <i class="iconfont icon-paixu"></i>
            </el-col>
            <el-col :span="22" class="border-line">
              <el-col :span="19" class="middle">
                <div class="steps-middle">
                  {{ $judgeEmpty(steps.monitoringNo) }}
                </div>
                <div class="steps-middle">
                  {{ steps.area }}
                </div>
              </el-col>
              <el-col :span="5" class="right">
                <div class="steps-button-grey" v-if="steps.state == 0">
                  未完成
                </div>
                <div class="steps-button-org" v-if="steps.state == 1">
                  已到达
                </div>
                <div class="steps-button-green" v-if="steps.state == 2">
                  已完成
                </div>
                <div class="steps-button-red" v-if="steps.state == 3">
                  未通过
                </div>
              </el-col>
            </el-col>
          </el-row>
        </div>
        <div v-else class="noData">未查询到数据</div>
        <div class="myMap">
          <div id="map-box"></div>
          <div
            class="infoWindow"
            ref="pointInfoWindow"
            v-show="infoWindowVisibility"
          >
            <el-col :span="8">
              <el-row>监测编号</el-row>
              <el-row>图斑类型</el-row>
              <!-- <el-row>行政区名称</el-row>
              <el-row>后时相</el-row>
              <el-row>特征</el-row> -->
              <el-row>监测面积</el-row>
            </el-col>
            <el-col :span="16">
              <el-row>{{ $judgeEmpty(infoWindowData.monitoringNo) }}</el-row>
              <el-row>{{ $judgeEmpty(infoWindowData.patternType) }}</el-row>
              <!-- <el-row>{{ $judgeEmpty(infoWindowData.monitoringNo) }}</el-row>
              <el-row>{{ $judgeEmpty(infoWindowData.monitoringNo) }}</el-row>
              <el-row>{{ $judgeEmpty(infoWindowData.monitoringNo) }}</el-row> -->
              <el-row>{{ $judgeEmpty(infoWindowData.area) }}</el-row>
            </el-col>
          </div>
        </div>
      </el-row>
    </el-dialog>
    <!--数据导出-->
    <!-- <el-dialog
      title="数据导出"
      :visible.sync="exportVisible"
      class="mini-dialog"
    >
      <el-form :model="exportForm" ref="exportForm" size="mini" inline>
        <el-form-item label="区域选择">
           <el-select v-model="exportForm.areaId" placeholder="请选择区域">
            <el-option
              v-for="item in photoAreaList"
              :key="item.id"
              :label="item.label"
              :value="item.id"
            >
            </el-option>
          </el-select> 
          <el-checkbox-group v-model="exportForm.areaId">
            <el-checkbox
              v-for="item in photoAreaList"
              :label="item.id"
              :key="item.id"
              >{{ item.label }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="exportVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveOrUpdate">确 定</el-button>
      </span>
    </el-dialog> -->
  </div>
</template>

<script>
import AMap from "AMap";
export default {
  name: "percentManagement",
  data() {
    return {
      myChart: "",
      queryForm: {
        operationTeam: "",
        areaIds: [],
        startTime: "",
        endTime: "",
      },
      rules: {
        startTime: [
          {
            required: true,
            trigger: "change",
            message: "请选择开始时间",
          },
        ],
        endTime: [
          {
            required: true,
            trigger: "change",
            message: "请选择结束时间",
          },
        ],
      },
      map: null,
      queryDate: "",
      pointInfoWindow: null,
      loading: false,
      noData: false,
      listVisibility: false,
      exportVisible: false,
      infoWindowVisibility: false,
      ok: false,
      tableData: [],
      detailTableData: [],
      stepsListData: [], // 所有点位数据【清单详情左边列表数据】
      pointsList: [], // 途经点数据
      areaList: [],
      photoAreaList: [],
      vehiclePosition: [],
      directionLnglat: [],
      infoWindowData: {},
      vehiclePolyline: null,
      workMarks: null,
      workMarksAll: [],
      startMarker: null,
      startPosition: "",
      endMarker: null,
      endPosition: "",
      workState: 0,
      vehicleState: 0,
      currentPage: 1,
      limit: 10,
      total: 0,
      molecule: 0,
      denominator: 0,
      // startDatePicker: this.expireTimeOptionStart(),
      // endDatePicker: this.expireTimeOptionEnd(),s
      optionProps: {
        value: "id",
        multiple: true,
      },
      percentData: {
        totalCompletionRate: "0%",
        totalPoints: 0,
        completionPoint: 0,
        hangInTheAir: 0,
        pastPoint: 0,
        plannedPoint: 0,
      },
    };
  },
  created() {
    this.getAreaList();
    this.getPercentData();
    this.getTableData();
  },
  mounted() {
    // // 关闭dialog的懒加载
    this.$refs.amapDialog.rendered = true;
  },
  updated() {
    if (!this.map) {
      this.initMap();
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.path == "/VehicleInfo") {
      let path = from.path; //path为定义的变量，不是vue的data定义的变量，当前生命周期data还未初始化
      sessionStorage.setItem("pathUrl", path);
    }
    next();
  },
  methods: {
    // 获取清单详情数据
    async getDetailTable(rowData) {
      this.noData = false;
      this.ok = false;
      let obj = {};
      obj.id = rowData.id;
      let { data: res } = await this.$axios.get(
        "/api/landOrder/subject/workOrderDetails",
        { params: obj }
      );
      if (res.code == 1) {
        // 获取任务点位数据【左边的列表数据，右边地图点位数据】
        this.stepsListData = res.data.list;
        this.pointsList = res.data.list;
        this.vehiclePosition = res.data.lnglat;
        this.vehicleState = res.data.vehicleState;
        this.directionLnglat = res.data.directionLnglat;
        if (res.data.lnglat.length > 0 && res.data.vehicleState != "") {
          this.ok = true;
        }
        // 获取详情表格【头部表格数据】
        this.detailTableData = res.data;
        if (this.detailTableData.oilVolume == "") {
          this.detailTableData.oilVolume = "-";
        } else {
          this.detailTableData.oilVolume =
            this.detailTableData.oilVolume + " L";
        }
        if (this.detailTableData.maintainMileage == "") {
          this.detailTableData.maintainMileage = "-";
        } else {
          this.detailTableData.maintainMileage =
            this.detailTableData.maintainMileage + " KM";
        }
        if (res.data.list.length == 0) {
          this.noData = true;
        }
      } else {
        this.$message.warning(res.msg);
      }
      this.handlePlanPointData();
    },
    // 处理任务点位数据
    handlePlanPointData() {
      let opts = []; // 途经点点位坐标
      let allOpts = []; // 所有点位坐标
      let stateList = []; // 途经点的状态数据【控制标记点不同图标】
      let planPoints = this.stepsListData.slice(0); // 途经点数据【不改变原数组】

      this.stepsListData.forEach((item) => {
        opts.push([item.logGd, item.latGd]);
        allOpts.push([item.logGd, item.latGd]);
        if (item.area == "") {
          item.area = "-";
        } else {
          item.area = item.area + " 亩";
        }
      });

      this.startPosition = allOpts[0]; //起点
      this.endPosition = allOpts[allOpts.length - 1]; // 终点
      // 将起点和终点从途经点数据中删除
      opts = opts.filter(
        (item) => item != this.startPosition && item != this.endPosition
      );

      planPoints.filter((item, index) => {
        let point = item.logGd;
        let start = this.startPosition[0];
        let end = this.endPosition[0];
        if (point == start || point == end) {
          planPoints.splice(index, 1);
        }
      });
      planPoints.forEach((item) => {
        stateList.push(item.state);
      });
      this.workState = stateList;
      this.pointsList = planPoints;
      this.$nextTick(() => {
        if (this.map) {
          if (this.startPosition && this.endPosition) {
            this.addMarkers();
            this.addWorkMarkers();
          }
          this.checkVehicleChange(allOpts);
        }
      });
      console.log(allOpts, opts);
    },

    // 根据点位规划车辆路线【根据起点、终点、途经点规划驾车路线】
    checkVehicleChange(opts) {
      let chunkList = this.chunk(opts, 16);
      let start = [];
      let end = [];
      for (let i = 0; i < chunkList.length; i++) {
        // 修订超过16个途经点时下一段路线的起始点
        start = chunkList[i][0];
        end = chunkList[i][chunkList[i].length - 1];
        // console.log(i, chunkList[i].length, chunkList[0], chunkList[1]);
        if (start.length > 0 && end.length > 0) {
          // 画路线轨迹;
          this.drawVehicleGuidelines(start, end, chunkList[i]);
        }
      }
    },

    // 处理数组数据，没40个数组为一组数据
    chunk(arr, size) {
      var result = [];
      for (var i = 0, len = arr.length; i < len; i += size) {
        result.push(arr.slice(i, i + size));
      }
      return result;
    },

    // 画线
    drawVehicleGuidelines(start, end, opts) {
      AMap.plugin("AMap.Driving", () => {
        let driving = new AMap.Driving({
          policy: AMap.DrivingPolicy.LEAST_TIME, // 根据起始点坐标规划路线
          hideMarkers: true, // 隐藏起点和终点的默认图标
          isOutline: false, // 是否显示路线描边
          autoFitView: true, //视线范围内
        });
        driving.search(
          start,
          end,
          { waypoints: [...opts] },
          (status, result) => {
            // 绘制路线节点，点连成线
            let path = [];
            for (let i = 0; i < result.routes[0].steps.length; i++) {
              // 先遍历坐标数组，将每一个坐标点存在path中
              let steps = result.routes[0].steps[i];
              for (let j = 0; j < steps.path.length; j++) {
                path.push(steps.path[j]);
              }
            }
            // console.log(path);
            this.vehiclePolyline = new AMap.Polyline({
              map: this.map,
              path: path,
              showDir: true,
              isOutline: true, // 开启外围描边
              outlineColor: "#015334", // 描边颜色
              strokeWeight: 4, // 线条宽度，默认为 1
              strokeColor: "#08c27a", // 线条颜色
              lineJoin: "round", // 折线拐点连接处样式
              lineCap: "round", // 线头部样式
            });
            this.map.setFitView(this.vehiclePolyline);
          }
        );
      });
    },

    // 添加点标记【起点、终点】
    addMarkers() {
      if (this.startMarker || this.endMarker) {
        this.map.remove(this.startMarker);
        this.map.remove(this.endMarker);
        this.startMarker = null;
        this.endMarker = null;
      }
      // 创建 AMap.Icon 实例：
      let startIcon = new AMap.Icon({
        size: new AMap.Size(24, 36), // 图标尺寸
        image: require("@/assets/images/geological/order/start.png"),
        imageSize: new AMap.Size(24, 36), // 根据所设置的大小拉伸或压缩图片
      });
      let endIcon = new AMap.Icon({
        size: new AMap.Size(24, 36),
        image: require("@/assets/images/geological/order/end.png"),
        imageSize: new AMap.Size(24, 36),
      });

      // 将 Icon 实例添加到 marker 上:
      this.startMarker = new AMap.Marker({
        position: this.startPosition,
        offset: new AMap.Pixel(0, 5),
        icon: startIcon, // 添加 Icon 实例
        anchor: "bottom-center",
        zoom: 13,
      });

      this.endMarker = new AMap.Marker({
        position: this.endPosition,
        offset: new AMap.Pixel(0, 5),
        icon: endIcon, // 添加 Icon 实例
        anchor: "bottom-center",
        zoom: 13,
      });

      this.map.add(this.startMarker);
      this.map.add(this.endMarker);
    },

    // 添加标记点【任务点、车辆定位点】
    addWorkMarkers() {
      if (this.workMarksAll.length > 0) {
        this.map.remove(this.workMarksAll);
        this.workMarksAll = [];
        this.workMarks = null;
      }
      let workImage;
      if (this.workState.length > 0) {
        this.workState.forEach((item, i) => {
          item = Number(item);
          switch (item) {
            case 0:
              workImage = require("@/assets/images/geological/order/unfinished.png");
              break;
            case 1:
              workImage = require("@/assets/images/geological/order/finish.png");
              break;
          }
          let workIcon = new AMap.Icon({
            size: new AMap.Size(20, 30),
            image: workImage,
            imageSize: new AMap.Size(20, 30),
          });
          let position = [this.pointsList[i].logGd, this.pointsList[i].latGd];
          // console.log(this.pointsList.length, position);
          this.workMarks = new AMap.Marker({
            position: position,
            offset: new AMap.Pixel(0, 5),
            anchor: "bottom-center",
            icon: workIcon, // 添加 Icon 图标 URL
          });
          this.workMarks.content = this.pointsList[i];
          // 监听任务点点击事件
          AMap.event.addListener(this.workMarks, "click", (e) => {
            // console.log(e.target.content);
            let position = [e.target.content.logGd, e.target.content.latGd];
            this.infoWindowData = e.target.content;
            // 点位信息窗体
            this.pointInfoWindow = new AMap.InfoWindow({
              isCustom: true, //使用自定义窗体
              content: this.$refs.pointInfoWindow,
              offset: new AMap.Pixel(27, -45),
              anchor: "top-left",
              closeWhenClickMap: true,
              autoMove: true,
            });
            this.infoWindowVisibility = true;
            this.pointInfoWindow.open(this.map, position);
          });
          this.workMarksAll.push(this.workMarks);
          this.map.add(this.workMarksAll);
          if (!this.listVisibility && this.pointInfoWindow) {
            this.pointInfoWindow.close();
          }
        });
      }
      if (this.ok) {
        let vehicleImage =
          this.vehicleState == 2
            ? require("@/assets/images/geological/order/online.png")
            : require("@/assets/images/geological/order/offline.png");
        let vehicleIcon = new AMap.Icon({
          size: new AMap.Size(24, 40),
          image: vehicleImage,
          imageSize: new AMap.Size(24, 40),
        });
        let vehicleMark = new AMap.Marker({
          position: this.vehiclePosition,
          offset: new AMap.Pixel(0, 5),
          anchor: "bottom-center",
          icon: vehicleIcon,
          autoRotation: true, // 车辆行驶过程中，方向可变属性
        });
        if (this.directionLnglat.length > 0) {
          // 判断车辆方向
          vehicleMark.moveAlong(this.directionLnglat, 50); //车辆行驶方向
        }
        this.map.add(vehicleMark);
      }
    },

    // 跳转至车辆详情
    toVehicleInfo(vin) {
      if (!vin) {
        this.$message.warning("车架号为空，无法查看车辆详情");
      } else {
        this.$router.push({
          name: "VehicleInfo",
          params: {
            vin: vin,
            active: "real",
          },
        });
        this.$store.state.MenuStore.menu_path = "进度管理 > 车辆管理";
      }
    },
    // 根据人员信息跳转到相应的人员单位管理页面
    toUnitManager(row) {
      console.log(row);
      this.$router.push("/UnitManagement");
      sessionStorage.setItem("devopsDeptId", row.deptId);
    },
    // 打开清单详情模态框
    listDetail(row) {
      console.log(row);
      this.listVisibility = true;
      this.getDetailTable(row);
      // // 获取已经添加的覆盖物
      // console.log('获取已经添加的覆盖物',this.map.getAllOverlays());
      // if (
      //   this.startMarker ||
      //   this.endMarker ||
      //   this.workMarksAll.length > 0 ||
      //   this.vehiclePolyline
      // ) {
      // 使用clearMap方法删除所有覆盖物
      this.map.clearMap();
      // }
    },
    exportData() {
      this.$refs.queryForm.validate(async (valid) => {
        if (valid) {
          let url = "";
          this.$confirm("确定导出当前查询条件下的数据吗？", "系统提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(async () => {
            url =
              "/api/landOrder/subject/exportTodayPoint?startTime=" +
              this.queryForm.startTime +
              "&endTime=" +
              this.queryForm.endTime +
              "&areaIds=" +
              this.queryForm.areaIds;
            window.location.href = url;
          });
        }
      });
    },
    query() {
      console.log(this.queryForm);
      this.getTableData();
    },
    reset() {
      this.$resetForm(this, "queryForm");
      // this.queryForm = this.$options.data().queryForm;
      console.log(this.queryForm);
      this.getTableData();
    },
    async getAreaList() {
      let { data: res } = await this.$axios.get("/api/sys/area/list");
      if (res.code == 1) {
        this.handleAreaList(res.data);
        // 处理最后一级children为空时不显示无数据空白节点页面
        let data = this.handleTreeData(res.data);
        this.areaList = data;
      } else {
        this.$message.warning(res.msg);
      }
    },
    // el-cascader 控件 最后一级出现空白 暂无数据 页面
    handleTreeData(data) {
      data.forEach((item) => {
        if (item.children.length == 0) {
          item.children = undefined;
        } else {
          this.handleTreeData(item.children);
        }
      });
      return data;
    },
    handleAreaList(areaList) {
      // 选中地拍区域
      let photoList = areaList.slice(areaList.length - 1)[0];
      areaList.forEach(() => {
        if (photoList.children.length != 1) {
          this.photoAreaList = photoList.children;
        } else {
          this.handleAreaList(photoList.children);
        }
      });
    },
    async getTableData() {
      // this.loading = true;
      let obj = {};
      obj.operationTeam = this.queryForm.operationTeam;
      obj.areaIds = this.queryForm.areaIds.join(",");
      obj.startTime = this.queryForm.startTime;
      obj.endTime = this.queryForm.endTime;
      obj.limit = this.limit;
      obj.page = this.currentPage;
      let { data: res } = await this.$axios.get("/api/landOrder/subject/list", {
        params: obj,
      });
      if (res.code == 1) {
        this.tableData = res.data.list;
        this.total = res.data.totalCount;
      } else {
        this.tableData = [];
      }
      // // 拿到数据关闭等待
      // this.loading = false;
    },
    initMap() {
      this.map = new AMap.Map("map-box", {
        resizeEnable: true,
        zoom: 12,
        zooms: [3, 20],
        expandZoomRange: true,
        mapStyle: "amap://styles/light",
      });
      AMap.plugin("AMap.Geolocation", () => {
        let geolocation = new AMap.Geolocation({
          enableHighAccuracy: true, //是否使用高精度定位，默认:true
          showButton: false,
          showMarker: false,
        });
        this.map.addControl(geolocation);
      });
    },
    /**
     * 计算百分比
     * @param   {number} molecule   分子
     * @param   {number} denominator 分母
     * @returns {number} 返回数百分比
     */
    // percentage(molecule, denominator) {
    //   let total = molecule + denominator;
    //   if (molecule == 0 || total == 0) {
    //     return "0%";
    //   }
    //   let result = Math.round((molecule / total) * 10000) / 100.0;
    //   return result.toFixed(2) + "%"; // 小数点后两位百分比
    // },
    async getPercentData() {
      let { data: res } = await this.$axios.get(
        "/api/landOrder/subject/completionRate"
      );
      if (res.code == 1) {
        this.percentData = { ...res.data };
      }
      this.initCharts();
    },
    initCharts() {
      // 基于准备好的dom，初始化echarts实例
      this.myChart = this.$echarts.init(
        document.getElementById("percentCharts")
      );
      // 指定图表的配置项和数据
      let option = {
        // tooltip: {
        //   trigger: "item",
        //   formatter: "{a} <br/>{b}: {c} ({d}%)",
        //   // 相对位置，放置在容器正中间
        //   position: ["100%", "70%"],
        // },
        color: ["#7ecf51", "#e7877b"],
        title: {
          // text: this.percentage(this.molecule, this.denominator),
          text: this.percentData.totalCompletionRate,
          left: "center",
          top: "30%",
          textStyle: {
            color: "#1e1e1e",
            fontSize: 30,
            align: "center",
            fontWeight: 400,
          },
        },
        graphic: {
          type: "text",
          left: "center",
          top: "60%",
          style: {
            text: "总完成率",
            textAlign: "center",
            fill: "#1e1e1e",
            fontSize: 14,
            fontWeight: 400,
          },
        },
        series: [
          {
            name: "作业完成情况",
            type: "pie",
            radius: ["100%", "80%"],
            avoidLabelOverlap: false,
            hoverAnimation: false,
            label: {
              normal: {
                show: false,
                position: "center",
              },
            },

            data: [
              { value: this.percentData.completionPoint, name: "已完成" },
              { value: this.percentData.hangInTheAir, name: "未完成" },
            ],
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      this.myChart.clear();
      this.myChart.setOption(option);
    },
    //pagesize改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    //页数改变时触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getTableData();
    },
    expireTimeOptionStart() {
      // 当结束时间不为空时，开始时间早于结束时间
      return {
        disabledDate: (time) => {
          if (this.queryForm.endTime) {
            return time.getTime() > new Date(this.queryForm.endTime).getTime();
          } else {
            return time.getTime() > Date.now(); //结束时间不选时，结束时间最大值小于等于当天
          }
        },
      };
    },
    expireTimeOptionEnd() {
      // 当开始时间不为空时，结束时间要晚于开始时间
      return {
        disabledDate: (time) => {
          if (this.queryForm.startTime) {
            return (
              time.getTime() <=
                new Date(this.queryForm.startTime).getTime() - 8.64e7 ||
              time.getTime() > Date.now()
            );
          } else {
            return time.getTime() > Date.now(); //开始时间不选时，结束时间最大值小于等于当天
          }
        },
      };
    },
    changeStart(val) {
      this.queryForm.startTime = val;
    },
    changeEnd(val) {
      this.queryForm.endTime = val;
    },
  },
};
</script>

<style lang='scss' scoped>
.percentManagement-container {
  margin: 20px;
  height: calc(100% - 40px);
  overflow-y: hidden;
  .top-title {
    color: #333;
    padding: 10px 20px;
    border-bottom: 1px solid #e4e4e4;
  }
  .line-row {
    display: inline-block;
    line-height: 40px;
    margin-right: 10px;
    color: #ccc;
    text-align: center;
  }
  .percentManagement-top {
    background: #fff;
    .top-content {
      display: flex;
      align-items: center;
      width: 100%;
      padding: 10px 0 10px 50px;
      color: #1e1e1e;

      .percentCharts {
        width: 140px;
        height: 140px;
      }
      .number {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;
        .number-top {
          font-size: 36px;
          color: #0066ff;
          font-weight: 700;
        }
        .number-bottom {
          font-size: 14px;
          font-weight: 700;
        }
      }
      .proportion {
        margin-left: 40px;
        .proportion-wrapper {
          width: 100%;
          text-align: center;
          .content {
            font-size: 24px;
            font-weight: 700;
            .molecule {
              color: #0c0;
            }
            .denominator {
              color: #f30;
            }
            .yesterday {
              color: #3cf;
            }
            .today {
              color: #f90;
            }
          }
          .line {
            height: 100%;
            padding-top: 4px !important;
          }
          .text {
            font-size: 14px;
          }
        }
      }
    }
  }
  .percentManagement-bottom {
    margin-top: 10px !important;
    height: calc(100% - 200px - 10px);
    background: #fff;
    .bottom-content {
      padding: 10px 20px;
      .list-detail {
        cursor: pointer;
        color: #0094ff;
        // text-decoration-line: underline;
      }
    }
  }
  .list-dialog {
    ::v-deep .el-dialog {
      width: 1212px;
      .el-dialog__body {
        padding: 0 !important;
      }
    }
    ::v-deep .el-dialog__body {
      position: relative;
      min-height: 600px;
    }
    .top {
      display: flex;
      justify-content: space-between;
      width: 100%;
      position: sticky;
      top: 0;
      z-index: 999;
      background: #fff;
      .table-left {
        margin-left: -2px;
        margin-right: 4px;
        table {
          text-align: center;
          color: #333;
          border: 1px solid #898989;
        }
        th {
          font-weight: 400;
          font-size: 13px;
          background: #e4e4e4;
        }
        td {
          font-size: 14px;
          color: #1e1e1e;
        }
        tr,
        td {
          width: 120px;
          height: 30px;
          line-height: 30px;
          border: 1px solid #898989;
        }
      }
      .table-right {
        display: flex;
        justify-content: flex-end;
        margin-right: -2px;
        table {
          text-align: center;
          color: #333;
          border: 1px solid #898989;
        }
        th {
          font-weight: 400;
          font-size: 13px;
          background: #e4e4e4;
        }
        td {
          font-size: 14px;
          color: #1e1e1e;
        }
        tr,
        td {
          width: 121px;
          height: 30px;
          line-height: 30px;
          border: 1px solid #898989;
        }
      }
    }
    .bottom {
      display: flex;
      justify-content: space-between;
      position: relative;
      height: 534px;
      .steps {
        width: 49%;
        position: absolute;
        left: 0;
        top: -60px;
        overflow: auto;
        max-height: 454px;
        border-radius: 0 !important;
        padding-bottom: 140px;
        .one-steps:nth-child(1) {
          margin-top: 60px !important;
        }
        .one-steps {
          height: 76px;
          padding: 10px 0;
          .left {
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .steps-number {
              width: 28px;
              line-height: 28px;
              color: #fff;
              font-size: 16px;
              text-align: center;
              background: #009dd9;
              border-radius: 50%;
            }
            .icon-paixu {
              position: absolute;
              top: 28px;
              font-size: 28px;
              color: #009dd9;
            }
          }
          .border-line {
            height: 100%;
            font-size: 14px;
            color: #000;
            padding: 0 20px 5px 15px !important;
            border-bottom: 1px solid #ccc;
            .middle {
              height: 100%;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
            }
            .right {
              height: 100%;
              display: flex;
              justify-content: flex-end;
              align-items: center;
              .steps-button-green {
                width: 64px;
                height: 28px;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #fff;
                background: #02d34c;
                border-radius: 16px;
              }
              .steps-button-grey {
                width: 64px;
                height: 28px;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #fff;
                background: #999;
                border-radius: 16px;
              }
              .steps-button-org {
                width: 64px;
                height: 28px;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #fff;
                background: #ff9000;
                border-radius: 16px;
              }
              .steps-button-red {
                width: 64px;
                height: 28px;
                display: flex;
                justify-content: center;
                align-items: center;
                color: #fff;
                background: #f6392a;
                border-radius: 16px;
              }
            }
          }
        }
      }
      .noData {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 0;
        top: -60px;
        width: 49%;
        height: calc(100% + 60px);
        line-height: calc(100% + 60px);
      }
      .myMap {
        width: 50%;
        position: absolute;
        right: 0;
        top: -60px;
        .table-top {
          position: absolute;
          top: 0;
          z-index: 1;
          background: #fff;
        }
        #map-box {
          width: 100%;
          height: 594px;
          border-bottom-right-radius: 6px;
        }
        .infoWindow {
          position: absolute;
          width: 190px;
          line-height: 24px;
          color: #000;
          padding: 10px 0 10px 10px;
          border-radius: 14px;
          background: rgba($color: #fff, $alpha: 0.8);
        }
      }
    }
  }
  /* 整个滚动条 */
  .steps {
    scrollbar-color: #666 #ccc;
    /* 第一个方块颜色，第二个轨道颜色(用于更改火狐浏览器样式) */
    scrollbar-width: thin;
    /* 火狐滚动条无法自定义宽度，只能通过此属性使滚动条宽度变细 */
    -ms-overflow-style: none;
  }
  /* 滚动条 */
  .steps:hover {
    overflow-y: auto;
  }
  .steps::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    border-radius: 32px !important;
  }
  // 滑块
  .steps::-webkit-scrollbar-thumb {
    background: #666;
  }
  // 外层轨道
  .steps::-webkit-scrollbar-track {
    border-radius: 32px !important;
    background: #ccc;
  }
  // 内层轨道【会覆盖外层轨道样式】
  .steps::-webkit-scrollbar-track-piece {
    background: #ccc;
  }

  /** 修改选择框icon样式 */
  ::v-deep .el-select .el-input .el-select__caret.el-input__icon::before {
    // content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    top: 50%;
    left: 50%;
    color: #333;
    font-weight: 700;
    transform: translate(-50%, -50%);
  }

  .el-form-item {
    margin-bottom: 10px !important;
  }

  ::v-deep .el-table {
    width: 100%;
    height: 460px;
  }
  ::v-deep .el-form-item__content .el-input__inner {
    height: 32px !important;
  }
  ::v-deep .el-cascader__tags {
    width: 60%;
    flex-wrap: nowrap;
  }

  .percentManagement-table /deep/ .el-table--mini td,
  .el-table--mini th {
    padding: 8px 0 !important;
  }

  @media screen and (max-width: 1700px) {
    ::v-deep .el-table {
      height: 400px;
    }
  }

  @media screen and (max-width: 1280px) {
    ::v-deep .el-table {
      height: 380px;
    }
  }

  ::v-deep .el-form {
    .el-input {
      width: 260px;
      .el-input__inner {
        width: 260px;
      }
    }
  }
}
</style>